var React = require('react');

function IconEllipsis (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M12 13a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm0 2a3 3 0 1 0 0-6 3 3 0 0 0 0 6zM20 13a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm0 2a3 3 0 1 0 0-6 3 3 0 0 0 0 6zM4 13a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm0 2a3 3 0 1 0 0-6 3 3 0 0 0 0 6z","fill":"currentColor"}));
}

IconEllipsis.defaultProps = {"width":"24","height":"24","fill":"none"};

module.exports = IconEllipsis;

IconEllipsis.default = IconEllipsis;
